import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { withApollo } from 'react-apollo';
import SelectWinnerPresentation from '../../presentation/SelectWinnerPresentation';
import useNomineeWinnerList from '../../hooks/useNomineeWinnerList.js';
import useRewardDetails from '../../../RnRCommonComponent/RewardList/hooks/useRewardDetails.js';
import { Spinner } from '../../../_shared/index.js';

const SelectWinnerContainer = (props) => {
	const { client } = props;
	const currentUser = useSelector((state) => state?.user?.currentUser);

	const { id } = useParams();

	const {
		nomineeList,
		nominationConfig = null,
		loading,
		nomineeVoterList,
		selectWinner,
		getNomineeVoterListById,
	} = useNomineeWinnerList(id);

	const { handleOpenViewReward, rewardDetails } = useRewardDetails(
		false,
		currentUser,
		client
	);

	const company = currentUser?.company;
	if (!company || !nominationConfig) return <Spinner />;
	return (
		<SelectWinnerPresentation
			selectWinner={nomineeList}
			nomineeVoterList={nomineeVoterList}
			getNomineeVoterListById={getNomineeVoterListById}
			loading={loading}
			selectWinnerFunc={selectWinner}
			nominationConfig={nominationConfig}
			handleOpenViewReward={handleOpenViewReward}
			rewardDetails={rewardDetails}
			client={client}
		/>
	);
};

export default withApollo(SelectWinnerContainer);
